import { render, staticRenderFns } from "./StallTable.vue?vue&type=template&id=6c84b1f9"
import script from "./StallTable.vue?vue&type=script&lang=js"
export * from "./StallTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports